import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { ModalHelperService } from 'src/app/services/modal-helper';
import { StorageService } from 'src/app/services/storage.service';
import { ActionDetailsComponent } from '../action-details/action-details.component';
import { EditWindowTypeComponent } from '../edit-window-type/edit-window-type.component';
import { PreConfigurationModalComponent } from '../pre-configuration-modal/pre-configuration-modal.component';
import { Router } from '@angular/router';
import { SavePdfModalComponent } from '../save-pdf-modal/save-pdf-modal.component';
import { OktaService } from 'src/app/services/okta.service';
import * as Constants from "../../utils/Constants";
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-action',
  templateUrl: './action.component.html',
  styleUrls: ['./action.component.scss'],
  standalone: false,
})
export class ActionComponent implements OnInit {
  @Input() openedFrom: 'configuration' | 'calculations' = 'calculations';
  configStatus: 'NOT_SAVED' | 'UNSAVED_CHANGES' | 'SAVED' = 'NOT_SAVED';
  isSavedProject: boolean = false;
  isLoggedIn: boolean = false;
  storedProject: any;
  private configStatusSub?: Subscription;
  constructor(private modalController: ModalController, private storageService: StorageService,
    private modalHelper: ModalHelperService, private translate: TranslateService,
    private router: Router, private oktaService: OktaService) { }

  async ngOnInit() {
    this.configStatus = this.storageService.getConfigStatus();
    this.configStatusSub = this.storageService.configStatus$.subscribe(status => {
      this.configStatus = status;
    });
    console.log("Config status", this.configStatus);
    await this.init();
  }

  async ionViewWillEnter() {
    this.configStatus = this.storageService.getConfigStatus();
    this.configStatusSub = this.storageService.configStatus$.subscribe(status => {
      this.configStatus = status;
    });
    console.log("Config status", this.configStatus);
  }

  private async init(): Promise<void> {
    try {
      const res = await this.storageService.getProject();
      this.storedProject = res ? JSON.parse(res) : null;
      this.isSavedProject = this.storedProject.id ? true : false;
    } catch (error) {
      console.error('Error initializing spacer data:', error);
    }
  }

  get isOpenedFromConfiguration(): boolean {
    return this.openedFrom === 'configuration';
  }
  get isOpenedFromCalculations(): boolean {
    return this.openedFrom === 'calculations';
  }
  async onCalculateResults() {
    await this.modalController.dismiss(null, 'calculateResults');
    this.router.navigate(['/tabs/calculations']);
  }

  onDeleteConfiguration() {
    this.openActionDetailsModal("delete");
  }

  async onRestartConfiguration() {
    this.modalController.dismiss();
    this.storageService.saveCurrentProject();
    const modal = await this.modalController.create({
      component: PreConfigurationModalComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        // Pass any data if needed
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm' && data) {
      console.log('Selected option:', data.selectedOption);
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['/tabs/configuration'], {
          queryParams: { configType: data.selectedOption }
        });
      });
    }
  }

  async onRenameConfiguration() {
    this.openActionDetailsModal("rename");
  }

  async onEditConfiguration() {
    this.router.navigate(['/tabs/configuration']);
    this.close();
  }

  onCalculatePerformances() {
  }

  async onDownloadPDF() {
    const modal = await this.modalController.create({
      component: SavePdfModalComponent,
      cssClass: 'configuration-modal',
      componentProps: {
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {

    }
  }

  async onSaveConfiguration() {
    const authStatus = await this.oktaService.isUserAuthenticated();
    this.isLoggedIn = authStatus;

    if (!this.isLoggedIn) {
      this.openActionDetailsModal("requiredLogin");
    } else {
      this.openActionDetailsModal("save");
    }
  }

  async openActionDetailsModal(modalType: string) {
    const modal = await this.modalController.create({
      component: ActionDetailsComponent,
      cssClass: 'configuration-modal',
      componentProps: {
        modalType: modalType
      }
    });

    await modal.present();

    const { data, role } = await modal.onWillDismiss();

    if (role === 'confirm') {

    }
  }

  close() {
    this.modalController.dismiss();
  }

  get mappedWindowType(): any {
    const id = this.storedProject?.windowtype;
    if (id === undefined || id === null) return null;
    return Constants.data_windows.find((w: any) => w.id === id) ?? null;
  }
  getWindowTypeName(): string {
    if (!this.mappedWindowType?.name) return '';
    return this.translate.instant(this.mappedWindowType.name);
  }

  getConfigurationSummary(): string {
    if (!this.storedProject) return '';

    const parts: string[] = [];

    // Window type name
    if (this.mappedWindowType?.name) {
      parts.push(this.getWindowTypeName());
    }

    // Frame type (if available)
    if (this.storedProject.windowframe?.type) {
      parts.push(this.translate.instant(this.storedProject.windowframe.type));
    }

    // Glass structure
    if (this.storedProject.windowglas?.structure) {
      parts.push(this.storedProject.windowglas.structure);
    }

    // Spacer name
    if (this.storedProject.spacer?.name) {
      parts.push(this.storedProject.spacer.name);
    }

    // if (this.storedProject.windowGlassBrandSettings?.countryId !== undefined) {
    //   parts.push('GB'); 
    // }

    return parts.join(' - ');
  }

  get isConfigNotSaved(): boolean {
    return this.configStatus === 'NOT_SAVED';
  }

  get isConfigHasUnsavedChanges(): boolean {
    return this.configStatus === 'UNSAVED_CHANGES';
  }

  get isConfigSaved(): boolean {
    return this.configStatus === 'SAVED';
  }

  ngOnDestroy() {
    this.configStatusSub?.unsubscribe();
  }
}
